import React from 'react'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

const OrganisationMetrics = ({ classes }) => {
  React.useEffect(() => {
    console.log('OrganisationMetrics component mounted')
  }, [])
  
  return (
    <div className={classes.container}>
      <h1>Analysis of Organisation and Job Metrics</h1>
      <p>Organisation Metrics and analytics coming soon...</p>
    </div>
  )
}

export default withStyles(styles)(OrganisationMetrics)
